










































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import UserInquiryCategory from '@/ts/UserInquiryCategory';
import UserInquiry from '@/ts/UserInquiry';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';

@Component
export default class SearchResultsView extends Mixins(LocalizationMethods) {
    constructor() {
        super();
    }

    get categories(): UserInquiryCategory[] {
        return this.$store.getters['UserTicketsAttributes/getInquiryCategories'];
    }

    get inquiries(): UserInquiry[] {
        return this.$store.getters['UserTicketsAttributes/getInquiries'];
    }

    get searchQuery(): string {
        return this.$store.getters['HomeAssistant/getSearchQuery'];
    }

    get filteredCategories(): any {
        if (this.searchQuery.trim() === '') {
            return [];
        }

        const regex = new RegExp(`${this.searchQuery}`, 'gmi');

        return this.categories.filter((category: UserInquiryCategory) => {
            return category.descriptions.some((descriptionObj: any) => {
                return regex.test(descriptionObj.description);
            });
        });
    }

    get filteredInquiries(): any {
        if (this.searchQuery.trim() === '') {
            return [];
        }

        const regex = new RegExp(`${this.searchQuery}`, 'gmi');

        return this.inquiries.filter((inquiry: UserInquiry) => {
            return inquiry.descriptions.some((descriptionObj: any) => {
                return regex.test(descriptionObj.description);
            });
        });
    }

    public getTargetedType(typeId: number) {
        return this.$store.getters['UserTicketsAttributes/getInquiryTypeById'](typeId);
    }

    public getTargetedCategory(categoryId: number) {
        return this.$store.getters['UserTicketsAttributes/getTypeInquiryCategoryById'](categoryId);
    }

    public changeView(type: string, item: any) {
        this.$store.commit(Mutations.SET_ACTIVE_HOME_ASSISTANT_TYPE, this.getTargetedType(item.typeId));

        if (type === 'category') {
            this.$store.commit(Mutations.SET_ACTIVE_HOME_ASSISTANT_CATEGORY, item);
            this.$store.commit(Mutations.SET_HOME_ASSISTANT_CURRENT_VIEW, 'QuestionsView');
        } else {
            this.$store.commit(Mutations.SET_ACTIVE_HOME_ASSISTANT_CATEGORY, this.getTargetedCategory(item.categoryId));
            this.$store.commit(Mutations.SET_ACTIVE_HOME_ASSISTANT_INQUIRY, item);
            this.$store.commit(Mutations.SET_ADD_NEW_TICKET_ANSWER_VISIBILITY, true);
        }
    }

    public created() {
        this.$store.commit(Mutations.SET_HOME_ASSISTANT_PREV_VIEW, 'SearchResultsView');
    }
}
